import { useFeatureFlags, useLocation } from '@atlassian/mpac-ui';
import React, { lazy, Suspense } from 'react';

import HelpDropdown from './HelpDropdown';

const InProductHelpCodeSplit = lazy(() =>
  import(/* webpackChunkName: "inProductHelp" */ './InProductHelp/InProductHelp')
);
const ShowHelp = () => {
  const { pathname } = useLocation();
  const { enableInProductHelpPartnerReporting } = useFeatureFlags();
  return enableInProductHelpPartnerReporting && pathname.includes('manage/vendors') ? (
    <Suspense fallback={<div />}>
      <InProductHelpCodeSplit />
    </Suspense>
  ) : (
    <HelpDropdown />
  );
};

export default ShowHelp;
